import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";
import { transparentize } from "polished";
type StyledProps = {
  mainImage?: boolean;
  image?: string;
  hero?: boolean;
};

export const Caption = styled.p`
  color: ${({ theme }) => theme.default.color.text.darkGrey} !important;
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont} !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
  text-align: left;
  line-height: 16px;
  font-size: 12px !important;
  margin-top: 12px !important;
`;

export const ImageWrapper = styled.div<StyledProps>`
  display: grid;
  grid-template-columns: 2fr 200px;
  column-gap: 10px;
  row-gap: 0.5rem;
  justify-content: space-between;
  height: ${({ hero }) => (hero ? "500px" : "350px")};
  margin-top: ${({ hero }) => (hero ? "32px" : "0")};
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 2fr 200px;
    height: 450px;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    height: 340px;
    grid-template-columns: 1fr;
  }
`;

export const ThumbnailWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
  row-gap: 10px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;

    column-gap: 10px;
    justify-content: space-around;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr 1fr 1fr;
    height: 90px;
    column-gap: 10px;
    justify-content: space-around;
  }
`;

export const MainImageWrapper = styled.div<StyledProps>`
  overflow: hidden;
  position: relative;
  background-position: center;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  display: flex;
  background-color: ${transparentize(0.2, "rgba(88, 88, 88, 0.9)")};
  align-items: center;
  height: ${({ hero }) => (hero ? "500px" : "350px")};
  border-radius: 16px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    height: 450px;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    height: 250px;
  }
`;

export const MainImage = styled.img<StyledProps>`
  object-fit: cover;
  height: 500px;
  width: 840px;
  @media (max-width: ${defaultBreakpoints.large}) {
    height: 100%;
    width: 100%;
  }
`;

export const Thumbnail = styled.div<StyledProps>`
  max-height: 100%;
  overflow: hidden;
  background-image: ${({ image }) => image && `url(${image})`};
  background-position: center;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  cursor: pointer;
  background-color: ${transparentize(0.2, "rgba(185, 185, 185, 0.9)")};
  border-radius: 16px;  
`;

export const SeeMoreThumbnail = styled.div<StyledProps>`
  max-height: 100%;
  overflow: hidden;
  background: ${({ image }) =>
    image &&
    `linear-gradient(rgba(0, 0, 0, 0.753), rgba(0, 0, 0, 0.692)), url(${image})`};
  background-position: center;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  cursor: pointer;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${transparentize(0.2, "rgba(185, 185, 185, 0.9)")};
  border-radius: 16px;
  p {
    margin: auto;
    position: absolute;

    @media (max-width: ${defaultBreakpoints.medium}) {
    }
  }
`;

export const ControlWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: auto 0;
  width: 100%;
  z-index: 10;
  position: absolute;
`;

export const ButtonlWrapper = styled.button`
  border: 0;
  background-color: ${transparentize(0.2, "rgba(88, 88, 88, 0.9)")};
  padding: 0.5rem;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    svg {
      fill: #a3a3a3;
    }
  }
  svg {
    font-size: 3rem;
    fill: white;
    @media (max-width: ${defaultBreakpoints.medium}) {
      font-size: 1.8rem;
    }
    :disabled {
      fill: #a3a3a3;
    }
  }
`;
